module.exports = __webpack_public_path__ + "img/iconleft.dbc562c7.png";